import { EMAIL_REQUIRED } from '../../constants/errorMessages';

export const requiredEmail = value => (value ? undefined : EMAIL_REQUIRED);

export default {};
